import type { FunctionComponent, PropsWithChildren } from "react"

import { createContext, useMemo } from "react"

export type JobAdsFetchProviderProps = PropsWithChildren<{
  isAlgoliaEnabled: boolean
}>

export const JobAdsFetchContext = createContext<JobAdsFetchProviderProps | undefined>(undefined)

export const JobAdsFetchProvider: FunctionComponent<JobAdsFetchProviderProps> = ({ isAlgoliaEnabled, children }) => {
  const value = useMemo(
    () => ({
      isAlgoliaEnabled,
    }),
    [isAlgoliaEnabled]
  )

  return <JobAdsFetchContext.Provider value={value}>{children}</JobAdsFetchContext.Provider>
}
